"use client";

import { LazyMotion, domAnimation } from "motion/react";

/** Lazy-loads motion features for subpages (nav fade-in, card hovers). */
export function SLMotionProvider({ children }: { children: React.ReactNode }) {
  return <LazyMotion features={domAnimation}>{children}</LazyMotion>;
}
